import React, { useEffect } from "react";
import {
  getPaymentInfo,
  getOneCompany,
  getReceipt,
  testDownloadS3,
} from "../BGService/kzgAPI";
import { QRCodeCanvas } from "qrcode.react";
import BarcodeGenerator from "../../Component/Code/BarcodeGenerator";
import classNames from "classnames";
import Styles from "./Payment.module.scss";
import PaymentModal from "../../Component/Modals/PaymentModals";
import { Link, useNavigate, useLocation } from "react-router-dom";
import qs from "qs";

const Info = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const location = useLocation();
  // location.search 會得到 "?a=1&b=2"
  const queryParams = qs.parse(location?.search, { ignoreQueryPrefix: true });

  const company = atob(queryParams?.data).split("_")[2];
  const month = atob(queryParams?.data).split("_")[1];
  const caseId = atob(queryParams?.data).split("_")[0];

  const [paymentInfoResp, setPaymentInfoResp] = React.useState({
    total: null,
    caseName: null,
    qrcode: null,
    barcode: [],
    infos: [],
  });

  const [isQRCodeModalOpen, setQRCodeModalOpen] = React.useState(false);
  const [isbarCodeModalOpen, setbarCodeModalOpen] = React.useState(false);
  const [companyObject, setCompanyObject] = React.useState();

  /** useEffect */
  useEffect(() => {
    fetchPaymentInfo(company, month, caseId);
    fetchOneCompany(company);
  }, []);
  // useEffect(() => {
  //   navigate("/systemRepair");
  // }, []);

  /**
   * Async Function
   */
  async function fetchPaymentInfo(company, month, caseId) {
    const response = await getPaymentInfo({
      company: company,
      month: month,
      caseId: caseId,
    });
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      navigate(`/payment_temp`);
    } else {
      setPaymentInfoResp(response.data);
    }
  }

  async function fetchOneCompany(company) {
    const response = await getOneCompany({
      id: company,
    });
    if (response.status !== 200) {
    } else {
      setCompanyObject(response.data);
    }
  }

  async function fetchReceipt(month, caseId, company) {
    const response = await testDownloadS3({
      month: month,
      caseId: caseId,
      company: company,
    });

    // window.open(response.data, '_blank');
    const link = document.createElement("a");
    link.href = response.data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleDownload = () => {
    // console.log(company);

    fetchReceipt(month, caseId, company);
  };

  const maskName = (name) => {
    if (!name || name.length < 2) return name || "";

    if (name.length === 2) {
      return name[0] + "O";
    }

    const firstChar = name[0];
    const lastChar = name[name.length - 1];
    const middleO = "O".repeat(name.length - 2);

    return firstChar + middleO + lastChar;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#e6ecef",
        marginTop: "2vh",
      }}
    >
      <div className={classNames("container")}>
        {/* <div
          className={classNames(Styles.payment__info__method__btn)}
          onClick={() => navigate(`/payment_temp/summary`)}
        >
          <div
            style={{
              marginBottom: "2vh",
            }}
            className={classNames(Styles.payment__btn)}
          >
            回上頁
          </div>
        </div> */}

        <div className={classNames(Styles.payment__info)}>
          <div
            className={classNames(
              "col-xs-12",
              "col-sm-12",
              "col-md-6",
              "col-lg-6",
            )}
          >
            <h4 className={classNames(Styles.payment__info__title)}>
              {maskName(paymentInfoResp.caseName)}
            </h4>
            <p className={classNames(Styles.payment__info__subtitle)}>
              {month}繳費帳號
            </p>
            <p className={classNames(Styles.payment__info__param)}>
              <div>台灣銀行 北花蓮分行 004</div>
              <span style={{ color: "blue" }}>
                {paymentInfoResp.barcode[1] ? (
                  <>
                    {paymentInfoResp.barcode[1].substr(0, 6)}-
                    {paymentInfoResp.barcode[1].substr(6, 7)}-
                    {paymentInfoResp.barcode[1].substr(13, 1)}
                  </>
                ) : null}
              </span>
            </p>
            <p className={classNames(Styles.payment__info__param)}>
              親愛的{companyObject?.name}服務用戶：
              {maskName(paymentInfoResp.caseName)}
              您好。
              <br />
              感謝您使用本機構長照服務
              <br />
              謹附上您：
              <br />
              {month} 長照服務 繳費通知單
              <br />
              金額：
              <span style={{ color: "blue" }}>{paymentInfoResp.total}</span>元
            </p>
          </div>
          <div className={classNames("col-sm-12", "col-md-6", "col-lg-6")}>
            <h4 className={classNames(Styles.payment__info__thirdtitle)}>
              服務明細
            </h4>
            <table style={{ margin: "0 auto" }}>
              <thead>
                <tr>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    服務項目
                  </th>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    項目金額
                  </th>
                  {/* <th className={classNames(Styles.payment__info__table__head)}>
                    自費比例
                  </th> */}
                  <th className={classNames(Styles.payment__info__table__head)}>
                    負擔金額
                  </th>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    支數
                  </th>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    小計
                  </th>
                </tr>
              </thead>

              <tbody>
                {paymentInfoResp.infos.map((info, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.serviceCode}
                      </td>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.normalAmount}
                      </td>
                      {/* <td
                        className={classNames(
                          Styles.payment__info__table__content
                        )}
                      >
                        {info.sharingRate}%
                      </td> */}
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.someAmount}
                      </td>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.count}
                      </td>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.sum}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {paymentInfoResp.isPaid === "N" ? (
          <div className={classNames(Styles.payment__info__method)}>
            <p className={classNames(Styles.payment__info__param)}>
              選擇繳款方式
            </p>
            {paymentInfoResp.total > 20000 ? (
              <div>超過繳款上限2萬元，請使用銀行轉帳或台灣PAY進行繳款。</div>
            ) : (
              <div
                className={classNames(Styles.payment__info__method__btn)}
                onClick={() => setbarCodeModalOpen(true)}
              >
                <div className={classNames(Styles.payment__btn)}>超商繳款</div>
              </div>
            )}
            {paymentInfoResp.qrcode !==null  ? (
              <div
                className={classNames(Styles.payment__info__method__btn)}
                onClick={() => setQRCodeModalOpen(true)}
              >
                <div className={classNames(Styles.payment__btn)}>台灣PAY</div>
              </div>
            ) : null}
          </div>
        ) : (
          <div className={classNames(Styles.payment__info__method)}>
            <p className={classNames(Styles.payment__info__param)}>已繳款</p>
            <div
              className={classNames(Styles.payment__info__method__btn)}
              // onClick={() => setbarCodeModalOpen(true)}
            >
              <div
                onClick={handleDownload}
                className={classNames(Styles.payment__btn)}
              >
                下載收據
              </div>
            </div>
          </div>
        )}

        <PaymentModal
          isOpen={isQRCodeModalOpen}
          onClose={() => setQRCodeModalOpen(false)}
        >
          <QRCodeCanvas value={paymentInfoResp.qrcode} size={256} />
        </PaymentModal>

        <PaymentModal
          isOpen={isbarCodeModalOpen}
          onClose={() => setbarCodeModalOpen(false)}
        >
          <div>
            {`請將螢幕轉成橫向`}
            <BarcodeGenerator codes={paymentInfoResp.barcode} />
          </div>
        </PaymentModal>
      </div>
    </div>
  );
};
export default Info;
